<div class="container">
  <h1 class="title">{{'locker.product.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="openNew()"><mat-icon>add</mat-icon></button>

  <!-- Tabla de resultados -->
  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [showPaginator]="true"
      [clientPagination]="true"
      [pageSizeOptions]="[25, 50, 100]"
      [rowClickable]="true"
      [rowClass]="productRowClass"
      tableClass="mat-elevation-z1"
      (rowClick)="openDetails($event.row)">

      <!-- category -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>{{'locker.product.table.header.category'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.category.code|traduccion }}</td>
      </ng-container>

      <!-- channel -->
      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>{{'locker.product.table.header.channel'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.channel|traduccion }}</td>
      </ng-container>

      <!-- price -->
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef> {{'locker.product.table.header.price'|traduccion}} </th>
        <td mat-cell *matCellDef="let element">
          <li *ngFor="let p of element.prices">
            {{ p.period }}/{{ p.unit|traduccion }} - {{ p.price | currency }}
              </li>
        </td>
      </ng-container>

    </app-data-table>
  </div>
</div>
